/**
 * Server-side name/email filter form. Deliberately not a live/debounced
 * search like OrganizationMembersPage's — fetchUsers() is a paginated API
 * call, not a client-side filter over an already-loaded collection, so
 * filtering only happens on explicit Search/Clear, matching the page's
 * original behavior.
 *
 * @param {string} name
 * @param {string} email
 * @param {function} onNameChange
 * @param {function} onEmailChange
 * @param {function} onSubmit
 * @param {function} onClear
 * @param {boolean} disabled
 * @param {boolean} isFiltered
 */
import React from "react";
import Input from "../../theme/untitled/Input/Input";
import Button from "../../theme/untitled/Button/Button";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./UsersPage.module.scss";

const UsersToolbar = ({ name, email, onNameChange, onEmailChange, onSubmit, onClear, disabled, isFiltered }) => (
  <form className={styles.toolbar} onSubmit={onSubmit}>
    <div className={styles.toolbarField}>
      <Input
        size="sm"
        label="User name"
        placeholder="Search by name"
        value={name}
        onChange={onNameChange}
        disabled={disabled}
      />
    </div>
    <div className={styles.toolbarField}>
      <Input
        size="sm"
        label="Email"
        placeholder="Search by email"
        value={email}
        onChange={onEmailChange}
        disabled={disabled}
      />
    </div>
    <div className={styles.toolbarActions}>
      <Button type="button" hierarchy="secondaryGray" size="sm" onClick={onClear} disabled={disabled || !isFiltered}>
        Clear
      </Button>
      <Button type="submit" hierarchy="primary" size="sm" iconLeading={<Icon name="SearchLg" />} disabled={disabled}>
        Search
      </Button>
    </div>
  </form>
);

export default UsersToolbar;
